// @module C3.ShoppingExtensions.ManufacturerPage
define('C3.ShoppingExtensions.ManufacturerPage.View'
,	[
	'c3_shoppingextensions_manufacturerpage.tpl'
	
	,	'SCView'
	/*,   'C3.ShoppingExtensions.Carousel.View'*/
	,   'C3.ShoppingExtensions.Carousel.ItemsViewUpdated'
	,   'AjaxRequestsKiller'
	//,	'Backbone'
	,   'GlobalViews.Breadcrumb.View'
	,   'Utils'
	,   'Backbone.CollectionView'
	,   'Facets.CategoryCell.View'
	,   'C3.ShoppingExtensions.Manufacturer.SubCategory.CirclesView'
	,   'c3_shoppingextensions_manufacturer_subcategory_circles.tpl'
	,   'facets_items_collection_view_cell.tpl'
	,   'facets_items_collection_view_row.tpl'
	,   'facets_items_collection.tpl'
	,   'Profile.Model'
    ]
, function (
	c3_shoppingextensions_manufacturerpage_tpl
	
	,	SCViewModule
	,   CarouselView
	,   AjaxRequestsKiller
	//,	Backbone
	,   GlobalViewsBreadcrumbView
	,   Utils
	,   BackboneCollectionView
	,   FacetsCategoryCellView
	,   C3ShoppingExtensionsManufacturerSubCategoryCirclesView
	,   c3_shoppingextensions_manufacturer_subcategory_circles_tpl
	,   facets_items_collection_view_cell_tpl
	,   facets_items_collection_view_row_tpl
	,   facets_items_collection_tpl
	,   ProfileModel
)
{
    'use strict';

    var SCView = SCViewModule.SCView;

     function ManufacturerPageView (options) {
     	SCView.call(this, options);

     	this.template = c3_shoppingextensions_manufacturerpage_tpl;
        this.options = options;
        this.category = options.category;
        this.container = options.container;
		this.application = options.application;
		this.manufacturerId = options.manufacturerId;
		this.tradeinManufacturerId = options.tradeinmanufacturerid;
		this.tradeinCategoryId = options.tradeincategoryid;
     }

     ManufacturerPageView.prototype = Object.create(SCView.prototype);
     ManufacturerPageView.prototype.constructor = ManufacturerPageView;

     ManufacturerPageView.prototype.getChildViews = function (){
     	return {
     		/*'Manufacturer-NewArrivals': function() {
					var self = this;

					var slideWidth = 283;
					var maxSlides = 4;

					var Configuration = this.application.configuration;
					var savedsearchConfiguration = Configuration.SavedSearchNewArrivals
					,   savedsearchConfigurationConfig = savedsearchConfiguration.config
					//console.log(savedsearchConfigurationConfig)

	      			 return new CarouselView({
					  	application : this.application,
					  	slideWidth : slideWidth,
					  	maxSlides : maxSlides,
					  	savedsearchid: savedsearchConfigurationConfig,
					  	manufacturer : this.manufacturerId,
					  	origin : 'newarrivals',
					  	configuration : Configuration,
					  	container : this.container
					  });
       	    },
       	    'Manufacturer-MostPopular': function() {
						var self = this;
						var slideWidth = 273;
						var maxSlides = 4;


						var Configuration = this.application.configuration;
						var savedsearchConfiguration = Configuration.SavedSearchMostPopular
						,   savedsearchConfigurationConfig = savedsearchConfiguration.config
		      			 return new CarouselView({
						  	application : this.application,
						  	slideWidth : slideWidth,
						  	maxSlides : maxSlides,
						  	savedsearchid: savedsearchConfigurationConfig,
						  	manufacturer : this.manufacturerId,
						  	origin : 'mostpopular',
						  	tradeinmanufacturerid : this.tradeinManufacturerId,
						  	tradeincategoryid : this.tradeinCategoryId,
					  		configuration : Configuration,
					  		container : this.container
						  });
       	    },*/
			'Manufacturer.Breadcrumb': function(){
       	    	const breadcrumb = [];

       	    	 breadcrumb[0] = {
		                href : '/',
		                'data-hashtag' : '#',
		                'data-touchpoint': "home",
		                hasDataHashtag: true,
		                hasDataTouchpoint: true,
		                text: "Home"
		          }

	            const list = this.category.breadcrumb;
	            const self = this;

	            _.each(list, function(bread) {
	                breadcrumb.push({
	                    text: bread.name,
	                    href: bread.fullurl
	                });
	            });
	            //console.log(breadcrumb)
                return new GlobalViewsBreadcrumbView({
	        			 pages: breadcrumb 
	        		});
       	    },
       	    'Manufacturer.CategoryCells': function() {
       	    	//console.log(this.category.categories)
       	    	var isPhoneDevice = Utils.isPhoneDevice()
						,   viewsPerRow = 6;

						if(isPhoneDevice)
						viewsPerRow = 3;

	            return new BackboneCollectionView({
	                //childView: FacetsCategoryCellView,
	                childTemplate : c3_shoppingextensions_manufacturer_subcategory_circles_tpl,
	                viewsPerRow: viewsPerRow,
					    childView: C3ShoppingExtensionsManufacturerSubCategoryCirclesView,
			          cellTemplate: facets_items_collection_view_cell_tpl,
						 rowTemplate: facets_items_collection_view_row_tpl,
						 template: facets_items_collection_tpl,
	                childViewOptions: {
	                    origin: 'manufacturerpage',
	                    application : this.application
	                },
	                collection: this.category
	                    ? this.category.categories
	                    : []
	            });
	        }
     	}
     }

     ManufacturerPageView.prototype.render = function () {
    	SCView.prototype.render.call(this);
    	
    }

    ManufacturerPageView.prototype.getContext = function () {
    	var subCat = this.category.categories;

    	 var profile = ProfileModel.getInstance()

    	return {
				name: this.category.name,
	            // @property {String} banner
	            banner: this.category.pagebannerurl,
	            // @property {String} description
	            description: this.category.description,
	            // @property {String} pageheading
	            pageheading: this.category.pageheading || this.category.name,
	            // @property {Boolean} hasBanner
	            hasBanner: !!this.category.pagebannerurl,	
	            subCategories : this.category.categories,
	            hasSubCategories : subCat.length > 0 ? true : false,	
	            isPhone : Utils.isPhoneDevice(),
				   isTablet : Utils.isTabletDevice(),
				   isLoggedIn : profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
			};
    }

     return ManufacturerPageView;

});
